export default "__VITE_ASSET__BazzbFy1__"